import React, { Component } from 'react';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import 'url-search-params-polyfill';
import ChatLandingCarousel from "./chatlanding-carousel/chatLandingCarousel";
import ChatLandingSearch from "./chatlanding-search/chatLandingSearch";
import ChatHelpCardGrid from "./chatlanding-help/chatHelpCardGrid";
import ChatLandingSupportGrid from "./chatlanding-support/chatLandingSupportGrid";
import cardsHelp from '../data/cardsHelp';
import cardsSupport from '../data/cardsSupport';
import carousels from '../data/carousels';

class ChatContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: true,
            messageList: [],
            message:'',
            channelData:''

        };
        this.handleIntentChange = this.handleIntentChange.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.openXA = this.openXA.bind(this);
        this.defaultEvent = this.defaultEvent.bind(this);

        this.textInput = React.createRef();
        this.cardsRef = React.createRef();
        this.placeHolder='What can I help you with today?';
    }

    componentDidMount() {
        const polarisScript = document.createElement('script');
        polarisScript.src = `https://polaris.xfinity.com/globalnav/polaris.${window.customElements ? 'wc' : 'es5'}.js`;
        polarisScript.async = true;
        document.head.appendChild(polarisScript);
    }

    defaultEvent(searchParam,type) {
        const left =  window.screen.width;
        const top = window.screen.height;
        this.cardsRef.current.clearSearch();
        this.openXA(searchParam,type);
    }

    handleKeyPress(searchParam,type) {
            this.cardsRef.current.clearSearch();
            this.openXA(searchParam,type);

    }

  /* initializeReactGA=()=> {
        ReactGA.initialize('UA-86399161-2');
        ReactGA.pageview(window.location.pathname +googletagmanager.com);
        console.log("t the tracker is set to ****************  "+ window.location.pathname + window.location.search);
    }
*/


    openXA(searchParam,type){
        console.log("the type is "+type);
       const left = window.screen.width;
        //const left = window.screen.width-400;//just for chrome
        const top = 400;
        const width = 370;
        const bottom=160;
        const height = window.screen.height-500;
        const ieLeft = window.screenLeft+window.screen.width;
        const ieTop = window.screenTop+1250;
        const ieWidth = 470;
        const ieHeight =  window.screen.height-550;
        const platform = 'AIQSDK';
        const channel = 'AIQSDK';
        const referrer='XA_landing';
        searchParam=escape(searchParam);
        //console.log("the IELeft is "+ieLeft +" and the IETop is "+ieTop);
        //console.log("the regular  is "+left + " and regular top is "+ window.screen.height);
        const endPoint = '/xfinityassistant/';

            let isIE = !!navigator.userAgent.match(/Trident/g) ||!!navigator.userAgent.match(/Edge/g)|| !!navigator.userAgent.match(/MSIE/g);
            if (isIE > 0) {
                let webEndPoint;
                if(type.trim()==='Link'){
                    webEndPoint = `${endPoint}?platform=${platform}&channel=${channel}&referrer=${referrer}`;}
                else
                {webEndPoint = `${endPoint}?${type}=${searchParam}&platform=${platform}&channel=${channel}&referrer=${referrer}`;}
                 window.open(webEndPoint, '_blank', `location=yes,scrollbars=yes,status=yes,height=${ieHeight},width=${ieWidth},toolbar=yes,resizable=yes,top=${ieTop},left=${ieLeft},false`);

               } else {
                let webEndPoint;
                if(type.trim()==='Link'){
                webEndPoint = `${endPoint}?platform=${platform}&channel=${channel}&referrer=${referrer}`;}
                else
                {webEndPoint = `${endPoint}?${type}=${searchParam}&platform=${platform}&channel=${channel}&referrer=${referrer}`;}
                window.open(webEndPoint, '_blank', `location=yes,height=${height},width=${width},scrollbars=yes,status=yes,toolbar=yes,resizable=yes,top=${top},left=${left},bottom=${bottom},false`);
        }
    }

    handleIntentChange(e){
        let message = Object.assign({}, this.state.message);
        message = e.target.value;
        this.setState({message});
    }

    render() {

        return (
            <div className="chat-Site"
            data-tracking='{"container":["xa-chat-landing"]}' data-dtm="container" data-dtm-level1="xfinity assistant" data-dtm-level2="landing asdfda"
            >
                <Header className="chat-header" />
                <ChatLandingSearch data-tracking innerRef={this.cardsRef} placeHolder={this.placeHolder} defaultEvent={this.defaultEvent} keyBoardEvent={this.handleKeyPress}/>
                <ChatLandingCarousel data-tracking defaultEvent={this.defaultEvent} carousels={carousels}/>
                <ChatHelpCardGrid data-tracking cards={cardsHelp} defaultEvent={this.defaultEvent}/>
                <ChatLandingSupportGrid data-tracking cardsSupport={cardsSupport} defaultEvent={this.defaultEvent}/>
               <Footer/>
            </div>
        );
    }
}

export default ChatContainer;
